export default "__VITE_ASSET__DOPfSRvn__"